import styled from "styled-components";

export default function Overlay() {
  return <OverlayElement />;
}

const OverlayElement = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 990;
  isolation: isolate;
`;
